// extracted by mini-css-extract-plugin
module.exports = {"headerSection":"styles_headerSection__Wv0pS","searchBox":"styles_searchBox__ZUzBX","faqContainer":"styles_faqContainer__kOjTx","showBtn":"styles_showBtn__rjiDb"};